var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9974 8.33073C11.8383 8.33073 13.3307 6.83834 13.3307 4.9974C13.3307 3.15645 11.8383 1.66406 9.9974 1.66406C8.15645 1.66406 6.66406 3.15645 6.66406 4.9974C6.66406 6.83834 8.15645 8.33073 9.9974 8.33073Z",
    fill: "#366EE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9974 2.28906C8.50162 2.28906 7.28906 3.50162 7.28906 4.9974C7.28906 6.49317 8.50162 7.70573 9.9974 7.70573C11.4932 7.70573 12.7057 6.49317 12.7057 4.9974C12.7057 3.50162 11.4932 2.28906 9.9974 2.28906ZM6.03906 4.9974C6.03906 2.81127 7.81127 1.03906 9.9974 1.03906C12.1835 1.03906 13.9557 2.81127 13.9557 4.9974C13.9557 7.18352 12.1835 8.95573 9.9974 8.95573C7.81127 8.95573 6.03906 7.18352 6.03906 4.9974Z",
    fill: "#366EE3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.875 18.3359C1.875 13.8486 5.5127 10.2109 10 10.2109C14.4873 10.2109 18.125 13.8486 18.125 18.3359C18.125 18.6811 17.8452 18.9609 17.5 18.9609C17.1548 18.9609 16.875 18.6811 16.875 18.3359C16.875 14.539 13.7969 11.4609 10 11.4609C6.20305 11.4609 3.125 14.539 3.125 18.3359C3.125 18.6811 2.84518 18.9609 2.5 18.9609C2.15482 18.9609 1.875 18.6811 1.875 18.3359Z",
    fill: "#366EE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountBlue);
export default __webpack_public_path__ + "static/media/account-blue.a66ad7410ddfcb0036d0447a68f4e5eb.svg";
export { ForwardRef as ReactComponent };